export default __webpack_public_path__ + "static/media/20220512 А170 (1) (1).8b2e3d41.pdf";